import React, {useState} from "react"
import {Form, Input, message, Modal} from "antd"
import {changePhone} from "../../../../../api/clubMemberList"

const ClubMemberEditPhone = ({memberId, account}) => {
    const items = [
        {
            label: "原电话",
            name: "account",
            children: <Input disabled/>,
            rules: []
        },
        {
            label: "新电话",
            name: "newAccount",
            children: <Input placeholder={"请输入新电话"}/>,
            rules: [
                {required: true, message: '请输入新电话'}
            ]
        },

    ]


    const [form] = Form.useForm()
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const fetchChangePhone = async () => {
        setIsLoading(true)
        const newAccount = form.getFieldValue("newAccount")
        await changePhone(memberId, newAccount).then((res) => {
            if (res.status) {
                message.success('修改成功')
                setIsShow(false)
                return
            }
            message.error(`修改失败：${res.detail}`)
        }).catch(err => {
            message.error(`获取电话失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleOnClick = () => {
        setIsShow(true)
        form.setFieldValue("account", account)
    }

    const handleOnCancel = () => {
        setIsShow(false)
        form.resetFields()
    }

    return (
        <div>
            <div onClick={handleOnClick}>
                修改电话
            </div>
            <Modal
                open={isShow}
                onCancel={handleOnCancel}
                onOk={() => {
                    form.submit()
                }}
                confirmLoading={isLoading}
                title={"修改电话"}
                destroyOnClose
            >
                <Form
                    style={{padding: "0 20px"}}
                    labelCol={{span: 4}}
                    wrapperCol={{span: 20}}
                    form={form}
                    initialValues={{
                        account: account,
                        newAccount: ""
                    }}
                    onFinish={() => {
                        fetchChangePhone()
                    }}
                >
                    {
                        items.map(item => (
                            <Form.Item label={item.label} name={item.name} key={item.name} rules={item.rules}>
                                {item.children}
                            </Form.Item>
                        ))
                    }
                </Form>
            </Modal>
        </div>
    )
}

export default ClubMemberEditPhone


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberEdit/component/ClubMemberEditPhone.js